export const removeCurrentUserTokens = () => {
  localStorage.removeItem('rightNowChartFacilityGroup');
  localStorage.removeItem('me');
  localStorage.removeItem('rightNowChartFacilityId');
  localStorage.removeItem('trendsFacilityGroupId');
  localStorage.removeItem('trendsFacilityId');
};
